import React from "react";
import {Button} from "@reside/ui";

import {downloadBlankPdf} from "../../../../../services/AdmissionsService";
import {useFacilitySettingsParams} from "../../../hooks/useFacilitySettingsParams";
import {useDownloadManager} from "../../../../../hooks/useDownloadManager";

type Props = Readonly<{
  facilityTemplate: string;
  workflowType: string;
  downloadTitle: string;
}>;

export const WorkflowDownloadEmptyPacketButton = ({
  facilityTemplate,
  workflowType,
  downloadTitle,
}: Props) => {
  const {facilityId} = useFacilitySettingsParams();
  const {start} = useDownloadManager();
  const isAdmission = workflowType.toLowerCase() === "admission";

  return (
    <Button
      color="primary"
      outline
      onClick={() => {
        start(downloadTitle, () =>
          downloadBlankPdf(
            facilityId,
            facilityTemplate,
            isAdmission ? {type: "full"} : {workflowType},
          ),
        );
      }}
    >
      Download
    </Button>
  );
};
